import { Injectable } from '@angular/core';

declare global {
   interface Window {
      dataLayer: any[];
      gtag: any;
   }
}

@Injectable({
   providedIn: 'root'
})
export class AnalyticsService {

   private platformType: 'ios' | 'android' | 'web' = 'web';
   private appVersion = '266';


   pushEvent(eventName: string, eventParams?: any): void {
     if (
       typeof window === 'undefined' ||
       !window.dataLayer ||
       typeof window.dataLayer.push !== 'function'
     ) {
       return;
     }

     try {
       window.dataLayer.push({
         event: eventName,
         ...(eventParams || {})
       });
     } catch (err) {
     }
   }

   sendConversion(conversionId: string, conversionLabel: string, conversionValue: number) {
      window.gtag('event', 'conversion', {
         send_to: 'YOUR_GA_TRACKING_ID/' + conversionId,
         value: conversionValue,
         currency: 'USD',
         transaction_id: '',
         event_callback: function () {
            if (typeof (window['onConversionComplete']) === 'function') {
               window['onConversionComplete'](conversionId);
            }
         }
      });
   }

   setPlatformType(platformType: 'ios' | 'android' | 'web') {
      this.platformType = platformType;
   }

   setAppVersion(appVersion: string) {
      this.appVersion = appVersion;
   }

   getPlatformType() {
      return this.platformType;
   }

   getAppVersion() {
      return this.appVersion;
   }
}
